// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__X1_pz","iframe":"styles_iframe__XCtp7"};